export default __webpack_public_path__ + "static/media/20.7122d474.jpg";